import React, { Component } from "react";
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  // Input,
  Label,
} from "reactstrap";
import { Formik, Field, Form } from "formik";
import { Uploader } from "rsuite";
// import Select from "react-select";
// import CustomSelectInput from "../../../../../../components/common/CustomSelectInput";
import IntlMessages from "../../../../../../helpers/IntlMessages";

import { Blog, UploaderImage } from "../../../../../../api/Api";

import { Editor } from "react-draft-wysiwyg";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import draftToHtml from "draftjs-to-html";
import { EditorState, convertToRaw } from "draft-js";

export default class AddConstant extends Component {
  state = {
    loading: false,
    picture: "",
    file: "",
    imagePreviewUrl: "",
    editorState: EditorState.createEmpty(),
    imagesId: [],
    initialValues: {
      title: "",
      description: "",
      addImage: "",
      content: "",
      tags: [],
    },
  };

  onEditorStateChange = (editorState) => {
    this.setState({
      editorState,
    });
  };

  handleChange = async ({ target }) => {
    try {
      let file = target.files[0],
        src = target.value;
      var reader = new FileReader();
      reader.onloadend = () => {
        this.setState({
          file,
          imagePreviewUrl: reader.result,
        });
      };
      reader.readAsDataURL(file);

      this.setState({ file, src });
    } catch (error) {}
  };

  handleSubmit = async (values, { resetForm, setSubmitting, setValues }) => {
    this.setState({ loading: true });
    try {
      let newValues = {
        ...values,
        content: draftToHtml(
          convertToRaw(this.state.editorState.getCurrentContent())
        ),
        // addImage: this.state.imagesId,
        cover: this.state.file,
      };
      await Blog.addBlog(newValues);

      //closing addNew Component
      this.props.toggleModal();

      //fetching data from dataBase
      this.props.dataListRender();

      // if (!this.state.isNew) {
      //   Swal.close();
      // }
      resetForm();
    } catch (error) {
      console.error(error);
      // toast(error.response.data.message);
    }
    this.setState({ loading: false });
  };

  handleChangeAlbum = async ({ target, ...e }) => {
    try {
      let myArray = [];

      for (const key in e) {
        myArray.push(e[key].blobFile);
      }

      const { data } = await UploaderImage.addImages(myArray);
      let imagesId = [];
      data.data.forEach((element) => {
        imagesId.push(element.id);
      });

      this.setState({ myArray, imagesId });
    } catch (error) {}
  };
  render() {
    const { editorState } = this.state;

    return (
      <>
        <Modal
          className="blogg"
          isOpen={this.props.modalOpen}
          toggle={this.props.toggleModal}
          wrapClassName="modal-right"
          backdrop="static"
        >
          {this.state.loading ? <div className="loading" /> : ""}
          <ModalHeader toggle={this.props.toggleModal}>
            <IntlMessages id="pages.add-new-modal-blog" />
          </ModalHeader>
          <ModalBody>
            <Formik
              initialValues={this.state.initialValues}
              // validationSchema={this.ValidationSchema}
              onSubmit={this.handleSubmit}
            >
              {(props) => (
                <Form className="form" onSubmitCapture={props.handleSubmit}>
                  <Label className="mt-4">
                    <IntlMessages id="title-moti" />
                  </Label>
                  <Field
                    name="title"
                    placeholder="تیتر  "
                    className="form-control"
                    type="text"
                    required
                  />

                  <Label className="mt-4">
                    <IntlMessages id="description-moti" />
                  </Label>
                  <Field
                    name="description"
                    placeholder="توضیحات  "
                    className="form-control"
                    type="text"
                    required
                  />

                  <Label className="mt-4">
                    <IntlMessages id="محتوا" />
                  </Label>
                  <Label className="mt-4">
                    <IntlMessages id="متن مقاله" />
                  </Label>
                  <div>
                    <Editor
                      editorState={editorState}
                      wrapperClassName="demo-wrapper"
                      editorClassName="demo-editor"
                      onEditorStateChange={this.onEditorStateChange}
                    />
                    {/* <textarea
                        disabled
                        value={draftToHtml(
                          convertToRaw(editorState.getCurrentContent())
                        )}
                      /> */}
                  </div>
                  {/* <Field
                    name="content"
                    placeholder="محتوا  "
                    className="form-control"
                    type="text"
                    style={{ marginBottom: "40px" }}
                    required
                  /> */}

                  <div className="custom-file">
                    <Field
                      name="cover"
                      placeholder="عکس"
                      className="custom-file-input"
                      type="file"
                      onChange={(e) => this.handleChange(e)}
                      accept="image/*"
                    />

                    <label
                      className="custom-file-label"
                      htmlFor="inputGroupFile01"
                    >
                      {this.state.src}
                    </label>
                    {this.state.imagePreviewUrl ? (
                      <img
                        style={{ width: "300px", marginTop: "20px" }}
                        src={this.state.imagePreviewUrl}
                      />
                    ) : (
                      ""
                    )}
                  </div>
                  {/* <CustomInput
                    name="picture"
                    placeholder="عکس  "
                    type="file"
                    accept="image/*"
                    onChange={(e) => this.handleChange(e)}
                    id="exampleCustomFileBrowser1"
                    // name="customFile"
                  /> */}
                  {/* {this.state.imagePreviewUrl ? (
                    <img
                      alt=""
                      style={{ width: "300px", marginTop: "20px" }}
                      src={this.state.imagePreviewUrl}
                    />
                  ) : (
                    ""
                  )} */}
                  <ModalFooter>
                    <div style={{ marginTop: "100px" }}>
                      <Button
                        color="secondary"
                        outline
                        onClick={this.props.toggleModal}
                      >
                        <IntlMessages id="pages.cancel" />
                      </Button>
                      <Button color="primary" type="submit">
                        <IntlMessages id="pages.submit" />
                      </Button>
                    </div>
                  </ModalFooter>
                </Form>
              )}
            </Formik>
          </ModalBody>

          {/* <ModalHeader toggle={toggleModal}>
          <IntlMessages id="pages.add-new-modal-title" />
        </ModalHeader>
        <ModalBody>
          <Label className="mt-4">
            <IntlMessages id="pages.name" />
          </Label>
          <Input />
          <Label className="mt-4">
            <IntlMessages id="pages.price" />
          </Label>
          <Input />
          <Label className="mt-4">
            <IntlMessages id="pages.duration" />
          </Label>
          <Input />
          <Label className="mt-4">
            <IntlMessages id="pages.category" />
          </Label>
          <Select
            components={{ Input: CustomSelectInput }}
            className="react-select"
            classNamePrefix="react-select"
            name="form-field-name"
            options={categories}
          />
          <Label className="mt-4">
            <IntlMessages id="pages.description" />
          </Label>
          <Input type="textarea" name="text" id="exampleText" />
          <Label className="mt-4">
            <IntlMessages id="pages.status" />
          </Label>
          <CustomInput
            type="radio"
            id="exCustomRadio"
            name="customRadio"
            label="ON HOLD"
          />
          <CustomInput
            type="radio"
            id="exCustomRadio2"
            name="customRadio"
            label="PROCESSED"
          />
        </ModalBody> */}
          {/* <ModalFooter>
          <Button color="secondary" outline onClick={toggleModal}>
            <IntlMessages id="pages.cancel" />
          </Button>
          <Button color="primary" onClick={toggleModal}>
            <IntlMessages id="pages.submit" />
          </Button>{" "}
        </ModalFooter> */}
        </Modal>
      </>
    );
  }
}
